import { render, staticRenderFns } from "./shitingDetail.vue?vue&type=template&id=2438ee30&scoped=true&"
import script from "./shitingDetail.vue?vue&type=script&lang=js&"
export * from "./shitingDetail.vue?vue&type=script&lang=js&"
import style0 from "./shitingDetail.vue?vue&type=style&index=0&id=2438ee30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438ee30",
  null
  
)

export default component.exports